export default class Sport {
    static fromData(data) {
        if (!data) {
            return;
        }

        const sport = new Sport();

        sport.id = data.id || null;
        sport.name = data.name;
        sport.colour = data.colour;
        sport.isArchived = data.isArchived;
        sport.isDeletable = data.isDeletable;
        sport.isArchivable = data.isArchivable;
        sport.reasonForNotArchivable = data.reasonForNotArchivable;
        sport.reasonForNotDeletable = data.reasonForNotDeletable;
        sport.delete = false;

        return sport;
    }

    static create() {
        const sport = new Sport();
        sport.id = null;
        sport.name = '';
        sport.colour = null;
        sport.edit = true;
        sport.delete = false;
        sport.isArchived = false;
        sport.isArchivable = false;
        sport.isDeletable = true;
        return sport;
    }

    equals(sport) {
        if (sport.id === null) {
            return false;
        }
        return sport.id === this.id;
    }

    serialize() {
        return {
            id: this.id || null,
            name: this.name,
            colour: this.colour,
            isArchived: this.isArchived || false,
            delete: this.delete || false,
        };
    }
}
